import { useEffect, useState } from "react";
import {
  resolveNowPlaying,
  stationLocal,
  type DayIndex,
  type NowPlaying,
  type ScheduleEntry,
} from "./radio-schedule";

export type LiveNow = NowPlaying & { today: DayIndex };

// Recomputes what's on air from the real clock, re-ticking each minute so the
// station rolls over shows without a reload. `entries` should be a stable
// reference (a module-level seed) so the effect doesn't resubscribe needlessly.
export function useNowPlaying(entries: ScheduleEntry[], timeZone = "Europe/London"): LiveNow {
  const compute = (): LiveNow => ({
    ...resolveNowPlaying(entries, new Date(), timeZone),
    today: stationLocal(new Date(), timeZone).day,
  });
  const [now, setNow] = useState<LiveNow>(compute);

  useEffect(() => {
    setNow(compute());
    const id = setInterval(() => setNow(compute()), 30_000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entries, timeZone]);

  return now;
}
